import React from "react";
import { Create, Edit, TextInput, LongTextInput } from "admin-on-rest";
import IconTitle from "../components/icon_title";
import AgencyForm from "./AgencyForm";
const AgencyDefaultValue = {
  users: [],
  contact: { contact: "", mobile: "", email: "" },
  custom: { api_key: "" }
};

const AgencyFormMain = props => {
  return (
    <AgencyForm {...props} defaultValue={AgencyDefaultValue}>
      <LongTextInput label="resources.agency.field.name" source="name" />
      <LongTextInput
        label="resources.agency.field.contact"
        source="contact.contact"
      />
      <TextInput
        label="resources.agency.field.mobile"
        source="contact.mobile"
      />
      <TextInput
        label="resources.agency.field.email"
        source="contact.email"
        type={"email"}
      />
      {props.record &&
        props.record.id && (
          <TextInput
            label="resources.agency.field.api_key"
            source="custom.api_key"
          />
        )}
    </AgencyForm>
  );
};

export const AgencyCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="agency" title={"resources.agency.newTitle"} />}
  >
    <AgencyFormMain {...props} />
  </Create>
);

export const AgencyEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="agency" title={"resources.agency.editTitle"} />}
  >
    <AgencyFormMain {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/agency/Detail.js